import type { Review } from '@/scopes/products/user-reviews/types'
import { horizontalGap, tk, useToken } from '@sunwebgroup/ui-components'
import useEmblaCarousel from 'embla-carousel-react'
import React from 'react'
import { styled } from 'styled-components'
import { Card, UserReview } from '../UserReview'

const Slider = styled.div`
  overflow: hidden;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${tk('spacing_2xs')}; // needed to show the shadow of the items

  ${horizontalGap('spacing_md')}

  ${Card} {
    min-width: 350px;
    width: 50%;
    height: 100%;
    box-shadow: ${tk('shadow_md_bottom')};
    @media ${tk('mq_desktop_md')} {
      min-width: unset;
    }
  }
`

interface ListProps {
  reviews?: Review[]
}

export function List({ reviews }: ListProps) {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    breakpoints: {
      [`${useToken<string>('mq_desktop_md')}`]: { active: false },
    },
  })
  return (
    <Slider ref={emblaRef}>
      <Wrapper>{reviews?.map(review => <UserReview key={review.id} {...review} />)}</Wrapper>
    </Slider>
  )
}
